import { Axios } from 'src/lib';
import { FronteggContext } from '@frontegg/rest-api';
import { superAdminLoadingSlice } from '../slices/condition.slice';
import {
  addFormConditions,
  getAllFormConditions,
  getAllFormTypes,
  getFormConditionsByIdConfig,
  getFormConditionsConfig,
  updateFormConditionsConfig,
} from '../lib/formconditions.url';
import {
  getAllFormConditionsSlice,
  getAllFormsSlice,
  getFormConditionByIdSlice,
  getFormConditionSlice,
} from '../slices/formconditions.slice';
import { showToastError } from 'src/utilities/errortoast';
import { showToastSuccess } from 'src/utilities/toast';

export const getAllFormConditionsAction = (uuid) => {
  return async (dispatch) => {
    dispatch(superAdminLoadingSlice(true));
    try {
      const { url } = getAllFormConditions();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Impersonate-Org-UUID': `${uuid}`,
        'Headless-Mode': true,
      };
      const data = {
        org_uuid: uuid,
      };
      const result = await Axios.post(url, data, { headers });
      const response = result?.data;
      if (result?.status === 200) {
        dispatch(getAllFormConditionsSlice(response));
        dispatch(superAdminLoadingSlice(false));
      }
    } catch (e) {
      dispatch(superAdminLoadingSlice(false));
      showToastError('Error occurred');
    }
  };
};

export const getAllFormsAction = (uuid, condition_id, request_type) => {
  return async (dispatch) => {
    dispatch(superAdminLoadingSlice(true));
    try {
      const { url } = getAllFormTypes();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      if (uuid && condition_id) {
        headers['Impersonate-Org-UUID'] = uuid;
      }
      const data = {
        org_uuid: uuid,
        condition_id: condition_id,
        type: request_type,
      };
      const result = await Axios.post(url, data, { headers });
      const response = result?.data?.form_list;
      if (result?.status === 200) {
        dispatch(superAdminLoadingSlice(false));
        dispatch(getAllFormsSlice(response));
      }
    } catch (e) {
      dispatch(superAdminLoadingSlice(false));
      showToastError('Error occurred');
    }
  };
};

export const addFormsConditions = (
  payload,
  setIsOpen,
  filterSetSelectedOrganizationUUID
) => {
  return async (dispatch) => {
    try {
      const { url } = addFormConditions();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await Axios.post(url, payload, { headers });
      if (result?.status === 200) {
        filterSetSelectedOrganizationUUID(payload?.org_uuid);
        setIsOpen(false);
        dispatch(getAllFormConditionsAction(payload?.org_uuid));
        showToastSuccess('Form condition added');
      }
    } catch (e) {
      dispatch(superAdminLoadingSlice(false));
      showToastError('Error occurred');
    }
  };
};

export const getAllFormConditionsById = (
  uuid,
  condition_id,
  setIsEditFormConditionModalOpen
) => {
  return async (dispatch) => {
    dispatch(superAdminLoadingSlice(true));
    try {
      const { url } = getFormConditionsByIdConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Impersonate-Org-UUID': `${uuid}`,
        'Headless-Mode': true,
      };
      const data = {
        org_uuid: uuid,
        condition_id: condition_id,
      };
      const result = await Axios.post(url, data, { headers });
      const response = result?.data;
      if (result?.status === 200) {
        dispatch(getFormConditionByIdSlice(response));
        dispatch(superAdminLoadingSlice(false));
        setIsEditFormConditionModalOpen(true);
      }
    } catch (e) {
      dispatch(superAdminLoadingSlice(false));
      showToastError('Error occurred');
    }
  };
};

export const updateFormsConditions = (payload, setIsOpen) => {
  return async (dispatch) => {
    try {
      const { url } = updateFormConditionsConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Impersonate-Org-UUID': `${payload?.org_uuid}`,
        'Headless-Mode': true,
      };
      const result = await Axios.put(url, payload, { headers });
      if (result?.status === 200) {
        setIsOpen(false);
        dispatch(getAllFormConditionsAction(payload?.org_uuid));
        showToastSuccess('Form condition updated');
      }
    } catch (e) {
      dispatch(superAdminLoadingSlice(false));
      showToastError('Error occurred');
    }
  };
};

export const getFormConditionsAction = (id, setIsOpen) => {
  return async (dispatch) => {
    try {
      const { url } = getFormConditionsConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const data = {
        form_id: id,
      };
      const result = await Axios.post(url, data, { headers });
      const response = result?.data?.content;
      if (result?.status === 200) {
        setIsOpen(true);
        dispatch(getFormConditionSlice(response));
      }
    } catch (e) {
      showToastError('Error occurred');
    }
  };
};
